import { useMemo } from 'react';
import { useFormFieldValue } from '../../formData';

export const useExternalMetadataAvailableKeys = externalMetadataKeyOptions => {
    const { value: externalMetadata = [] } = useFormFieldValue({ field: 'externalMetadata.data' });

    return useMemo(() => {
        const metadataKeysSet = externalMetadata.map(item => item.key);
        return externalMetadataKeyOptions.filter(option => !metadataKeysSet.includes(option.value));
    }, [externalMetadataKeyOptions, externalMetadata]);
};
